// extracted by mini-css-extract-plugin
export default {"groupContainer":"Group-module__groupContainer___B7W1R","groupBody":"Group-module__groupBody___pbTmP","groupContent":"Group-module__groupContent___hw6M6"};